import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ConstantInput from "../../../../components/sales/Input/constantInput/constantInput";
import DropDownInput from "../../../../components/sales/Input/dropDownInput/dropDownInput";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import { DatePickerInput } from "rc-datepicker";
import { FormGroup } from "react-bootstrap";
import { useParams } from "react-router-dom";
import "react-times/css/classic/default.css";
import FormSection from "../../../../components/sales/formSection/formSectionNew";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import DatePicker from "components/sales/datePicker/datePicker";
import FileUpload from "../../../../components/sales/fileUpload/fileUpload";
import "./createMOM.css";
import { set } from "date-fns";
//import { toast, ToastContainer } from "react-toastify";

const styles = {
  fontFamily: "sans-serif",
  width: "500px",

  border: "1px solid #eee",
  background: "#f3f3f3",
  padding: "25px",
  margin: "20px",
};

const CreateMom = ({
  match,
  history,
  getCorpClientList,
  corpClientList,
  getClientEmail,
  clientEmail,
  getMeetingById,
  createAndSendMom,
  documentUploadUrlPublic,
  documentUrlDataPublic,
}) => {
  const inputs = {
    //
  };
  const { id } = useParams();
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState(inputs);
  const [isFocus, setIsFocus] = useState(false);
  const [addItem, setAddItem] = useState(1);
  const [addCCitem, setaddCCitem] = useState(1);
  const [inputList, setInputList] = useState([
    {
      agenda: "",
      timeline: "",
      responsibility: "",
      description: "",
      assignedPerson: "",
    },
  ]);
  const [inputList2, setInputList2] = useState([{ cc: "" }]);
  const [disabled, setDisabled] = useState(true);
  const [category, setCategory] = useState(null);
  const [toState, setToState] = useState(null);
  const [clientId, setClientId] = useState(null);
  const [body, setBody] = useState("");
  const [note, setNote] = useState("");
  const [momImage, setMomImage] = useState([{ url: "" }]);
  const [subject, setSubject] = useState(null);
  const [complaintRaised, setComplaintRaised] = useState(null);
  const [complaintResolved, setComplaintResolved] = useState(null);
  const [monthlyAverage, setMonthlyAverage] = useState(null);
  const [showSubject, setShowSubject] = useState(false);
  // const [emails, setEmails] = useState<string[] | []>([]);
  // CC MAIL

  const [ccitems, setCCItems] = useState([]);
  const [ccvalue, setCCValue] = useState("");
  const [ccerror, setCCError] = useState(null);

  // TO EMAIL
  const [items, setItems] = useState([]);
  const [value, setValue] = useState("");
  const [error, setError] = useState(null);

  const handleKeyDown = (evt) => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();
      console.log(value);
      //   var value = value.trim();

      if (value && isValid(value)) {
        setItems([...items, value]);
        setValue("");
      }
    } else if (value && value.slice(-1) === ",") {
      // KeyCode For comma is 188
      evt.preventDefault();
      console.log(value);
      //   var value = value.trim();
      const chackValue = value.slice(0, -1);
      if (chackValue && isValid(chackValue)) {
        setItems([...items, chackValue]);
        setValue("");
      }
    }
  };

  const handleChange = (evt) => {
    setValue(evt.target.value);
    setError(null);
  };

  const handleDelete = (item) => {
    console.log(item);
    const list = [...items];

    list.splice(item, 1);
    setItems(list);
    //     setItems({
    //     items: items.filter(i => i !== item)
    // });
  };

  const isValid = (email) => {
    let error = null;

    if (isInList(email)) {
      error = `${email} has already been added.`;
    }

    if (!isEmail(email)) {
      error = `${email} is not a valid email address.`;
    }

    if (error) {
      setError(error);
      toast.error(error);
      return false;
    }

    return true;
  };

  const isValidAssignedEmail = (email) => {
    let error = null;

    if (isInList(email)) {
      error = `${email} has already been added.`;
    }

    if (!isEmail(email)) {
      error = `${email} is not a valid email address.`;
    }

    if (error) {
      setError(error);
      toast.error(error);
      return false;
    }

    return true;
  };

  const isInList = (email) => {
    return items.includes(email);
  };

  //   TO MAIL END

  const isEmail = (email) => {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email);
  };

  //   CC MAIL START
  const cchandleKeyDown = (evt) => {
    if (["Enter", "Tab", ","].includes(evt.key)) {
      evt.preventDefault();
      // console.log(value)
      //   var value = value.trim();

      if (ccvalue && ccisValid(ccvalue)) {
        setCCItems([...ccitems, ccvalue]);
        setCCValue("");
      }
    } else if (ccvalue && ccvalue.slice(-1) === ",") {
      // KeyCode For comma is 188
      evt.preventDefault();
      const ccchackValue = ccvalue.slice(0, -1);
      if (ccchackValue && ccisValid(ccchackValue)) {
        setCCItems([...ccitems, ccchackValue]);
        setCCValue("");
      }
    }
  };

  const cchandleChange = (evt) => {
    setCCValue(evt.target.value);
    setCCError(null);
  };

  const cchandleDelete = (item) => {
    // console.log(item);
    const list = [...ccitems];

    list.splice(item, 1);
    setCCItems(list);
    //     setItems({
    //     items: items.filter(i => i !== item)
    // });
  };

  const ccisValid = (email) => {
    let error = null;

    if (ccisInList(email)) {
      error = `${email} has already been added.`;
    }

    if (!isEmail(email)) {
      error = `${email} is not a valid email address.`;
    }

    if (error) {
      setError(error);
      toast.error(error);
      return false;
    }

    return true;
  };

  const ccisInList = (email) => {
    return ccitems.includes(email);
  };

  // CC MAIL END
  //MAIL END

  const handleInputValue = (val, key, index) => {
    const list = [...inputList2];
    // console.log(list);
    list[index][key] = val;
    setInputList2([...list]);
  };

  const handleInput2Value = (val, key, index) => {
    const list = [...inputList];
    console.log(list);
    list[index][key] = val;
    setInputList([...list]);
  };

  const handleTextAreaValue = (val, key, index) => {
    const list = [...inputList];
    console.log(val.target.value);
    list[index][key] = val.target.value;
    setInputList([...list]);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleCCRemoveClick = (index) => {
    const list = [...inputList2];
    list.splice(index, 1);
    setInputList2(list);
  };

  const handleAddClick = () => {
    var size = Object.keys(inputList).length;
    setInputList([
      ...inputList,
      {
        agenda: "",
        timeline: "",
        responsibility: "",
        description: "",
        assignedPerson: "",
      },
    ]);
  };

  const handleCCAddClick = () => {
    var size = Object.keys(inputList2).length;
    setInputList2([...inputList2, { cc: "" }]);
  };

  const handleSubmit = async () => {
    const data = {
      inputList: inputList,
      inputList2: ccitems,
      category: category,
      to: items,
      client_id: clientId,
      site_id: siteId,
      meeting_id: id,
      body: body,
      note: note,
      document: momImage,
      subject: subject,
      complaintRaised: complaintRaised,
      complaintResolved: complaintResolved,
      monthlyAverage: monthlyAverage,
    };

    const isAssignedPersonEmailValid = inputList.every((item) => {
      const assignedPersonEmail = item.assignedPerson;
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return !assignedPersonEmail || emailRegex.test(assignedPersonEmail);
    });

    if (!isAssignedPersonEmailValid) {
      toast.error("Please enter valid email addresses for assignedPerson");
      return;
    }
    console.log(data);
    // return false;
    (async () => {
      setIsLoading(true);
      const res = await createAndSendMom(data);
      setIsLoading(false);
      if (res) {
        if (res == true) {
          toast.success("MoM send successfully.");
          setTimeout(
            history.push(`${baseUrl}/brand-activation/scheduled-meeting`),
            7000
          );
        }
      }
    })();
  };

  const handleDateHide = () => {
    if (formData.scheduled_date) {
      setIsFocus(true);
    }
  };

  const handleDateChange = (date, dateString) => {
    console.log(date);
    // setData({ ...formData, scheduled_date: dateString });
  };

  useEffect(() => {
    if (getCorpClientList !== null)
      (async () => {
        setIsLoading(true);
        await getCorpClientList(match.params.siteId);
        setIsLoading(false);
      })();
  }, [getCorpClientList, match.params.siteId]);

  useEffect(() => {
    setSiteId(match.params.siteId);
    if (match.params.siteId == 0) {
      setShowSubject(true);
    }
    if (getClientEmail !== null) {
      (async () => {
        setIsLoading(true);
        await getClientEmail(match.params.siteId,match.params.id);
        setIsLoading(false);
      })();
    }
  }, [getClientEmail, match.params.siteId,match.params.id]);

  useEffect(() => {
    setItems([]);
    if (clientEmail?.email != null && clientEmail?.email != "") {
      setToState(clientEmail?.email);
      setItems([...clientEmail?.email]);
    }
  }, [clientEmail]);

  useEffect(() => {
    setClientId(clientEmail?.clientId);
  }, [clientEmail]);

  useEffect(() => {
    setSubject(clientEmail?.name);
  }, [clientEmail]);

  useEffect(() => {
    setBody(clientEmail?.body);
  }, [clientEmail]);

  useEffect(() => {
    setNote(clientEmail?.note);
  }, [clientEmail]);

  const saveMomDoc = (val) => {
    console.log(val);
    const list = [...momImage];
    list[0]["url"] = val;
    setMomImage([...list]);
  };
  console.log("here" + items);
  return (
    <Layout
      title={localization.createMom}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            {/* MAIL */}

            <>
              <div className="row">
                {items &&
                  items.length > 0 &&
                  items.map((item, index) => (
                    <div className="col-md-3" key={{ index }}>
                      <div className="tag-item">
                        {item}
                        <button
                          type="button"
                          className="button"
                          onClick={() => handleDelete(index)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="form-group">
                <input
                  className={
                    "input form-control inline-css scrollbar-styling" +
                    (error && " has-error")
                  }
                  value={value}
                  placeholder="To   - press (comma, Tab) to add "
                  onKeyDown={handleKeyDown}
                  onChange={handleChange}
                  // onPaste={handlePaste}
                />
                <label className="placeholder ">To </label>
              </div>
            </>

            {/* END MAIL */}
            {/* CC MAIL */}

            <>
              <div className="row">
                {ccitems &&
                  ccitems.map((item, index) => (
                    <div className="col-md-3" key={{ index }}>
                      <div className="tag-item" key={{ item }}>
                        {item}
                        <button
                          type="button"
                          className="button"
                          onClick={() => cchandleDelete(index)}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="form-group">
                <input
                  className={
                    "input form-control inline-css scrollbar-styling" +
                    (ccerror && " has-error")
                  }
                  value={ccvalue}
                  placeholder="CC   - press ,(comma, Tab) to add "
                  onKeyDown={cchandleKeyDown}
                  onChange={cchandleChange}
                  // onPaste={handlePaste}
                />
                <label className="placeholder ">CC </label>
              </div>
            </>

            {/* END CC MAIL */}
            <div className="row">
              <div className="col-md-6 col-sm-12">
                <div className="w3-text-red w3-align-left"></div>
                <DropDownInput
                  name="category"
                  data={[
                    {
                      name: "First Interaction - Carnival",
                      id: "First Interaction - Carnival",
                    },
                    {
                      name: "First interaction - helpdesk",
                      id: "First interaction - helpdesk",
                    },
                    { name: "Carnival Meeting", id: "Carnival Meeting" },
                    {
                      name: "Installation sort out",
                      id: "Installation sort out",
                    },
                    { name: "Handover - sort out", id: "Handover - sort out" },
                    {
                      name: "Post carnival (thank you note)",
                      id: "Post carnival (thank you note)",
                    },
                    {
                      name: "Training (tag activation, dashboard)",
                      id: "Training (tag activation, dashboard)",
                    },
                    { name: "Payment followup", id: "Payment followup" },
                    {
                      name: "Excessive Payment delay",
                      id: "Excessive Payment delay",
                    },
                    { name: "System Issues", id: "System Issues" },
                    {
                      name: "Sales - EV, Solar, ANPR, Add OnS",
                      id: "Sales - EV,Solar,ANPR,Add OnS",
                    },
                    {
                      name: "Sales implementation (EV, ANPR, SOLAR)",
                      id: "Sales implementation (EV,ANPR,SOLAR)",
                    },
                    {
                      name: "Carnival set up meeting ",
                      id: "Carnival set up meeting",
                    },
                    { name: "Contract renewal", id: "Contract renewal" },
                    {
                      name: "Custom (Agenda to be defined by RM in this field)",
                      id: "Custom (Agenda to be defined by RM in this field)",
                    },
                  ]}
                  label={localization.category}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  getIdValue={(val) => setCategory(val.id)}
                />
                <div className="validation">{}</div>
              </div>
              {showSubject === true ? (
                <>
                  <div className="col-md-6 col-sm-12">
                    <ConstantInput
                      name="subject"
                      label={localization.subject}
                      type="text"
                      value={subject}
                      //required={true}
                      //isStarRequired={true}
                      //errorMsg={localization.isRequired}
                      //disabled={disabled}
                      handleChange={(val) => {
                        setSubject(val);
                      }}
                    />
                  </div>
                </>
              ) : (
                ""
              )}

              <div>
                {/* {addCCitem === 1 ? (
                                <>
                                {inputList2.map((x, i) => {
                                return (
                                    <div className="form-group" key={i}>

                                    <div className="col-md-12 col-sm-12">
                                        <ConstantInput
                                            name="cc"
                                            type="email"
                                            className={`inline-css scrollbar-styling`}
                                            label={localization.cc}
                                            value={x.cc}
                                            errorMsg={localization.isRequired}
                                            handleChange={(val) => {
                                              handleInputValue(val, 'cc',i);
                                            }}
                                        />
                                    </div>

                                        {inputList2.length !== 1 && 
                                            <div className="col-md-2 col-sm-5">
                                            <button
                                            onClick={() => handleCCRemoveClick(i)} 
                                            className="mr10 btn btn-sm btn-danger">Remove</button>
                                            </div>
                                            }
                                            {inputList2.length - 1 === i && 
                                            <div className="col-md-2 col-sm-5">
                                            <button className="btn btn-sm btn-primary" onClick={handleCCAddClick}>Add</button>
                                            </div>
                                        }
            
                                    </div>
                                    
                                );
                                })}
                                </>
                               ) : (addCCitem === 2) ?
                                {}
                               : null} */}
              </div>
              <div className="col-md-12 col-sm-12">
                <hr />
                <TextAreaInput
                  name="body"
                  type="text"
                  rows={2}
                  className={`inline-css scrollbar-styling`}
                  label={localization.emailBody}
                  value={body}
                  inputValue={body}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => {
                    setBody(e.target.value);
                  }}
                />
              </div>
              <div>
                {addItem === 1 ? (
                  <>
                    {inputList.map((x, i) => {
                      return (
                        <div className="" key={{ i }}>
                          <div className="container row">
                            <div className="col-md-3 col-sm-12">
                              <DropDownInput
                                name="agenda"
                                data={corpClientList.agenda}
                                label={localization.agenda}
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                getIdValue={(val) => {
                                  handleInput2Value(val.id, "agenda", i);
                                }}
                                value={x.agenda}
                              />
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <TextAreaInput
                                type="text"
                                rows={3}
                                cols={70}
                                className={`inline-css scrollbar-styling`}
                                label={localization.tasks}
                                value={x.description}
                                inputValue={x.description}
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(e) =>
                                  handleTextAreaValue(e, "description", i)
                                }
                              />
                            </div>

                            <div className="col-md-3 col-sm-12">
                              <DatePicker
                                handleChange={(val) =>
                                  handleInput2Value(val, "timeline", i)
                                }
                                label={`Deadline`}
                                required={false}
                                value={x?.timeline}
                              />
                            </div>

                            <div className="col-md-3 col-sm-12">
                              <DropDownInput
                                name="responsibility"
                                data={[
                                  { name: "Client", id: "Client" },
                                  { name: "Park+", id: "Park+" },
                                ]}
                                label={localization.responsibility}
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                getIdValue={(val) => {
                                  handleInput2Value(
                                    val.id,
                                    "responsibility",
                                    i
                                  );
                                }}
                              />
                            </div>
                            <div className="col-md-3 col-sm-12">
                              <ConstantInput
                                label={localization.reponsiblePersonMail}
                                type="email"
                                required={true}
                                isStarRequired={true}
                                errorMsg={localization.isRequired}
                                handleChange={(val) => {
                                  handleInput2Value(val, "assignedPerson", i);
                                }}
                              />
                            </div>
                            <div className="col-md-3 col-sm-12 d-flex">
                              {inputList.length !== 1 && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    onClick={() => handleRemoveClick(i)}
                                    className="mr10 btn btn-sm btn-danger"
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                              {inputList.length - 1 === i && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleAddClick}
                                  >
                                    Add
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                          <span class="section-divider"></span>
                        </div>
                      );
                    })}
                  </>
                ) : addItem === 2 ? (
                  {}
                ) : null}
              </div>

              <div className="col-md-12 col-sm-12">
                <TextAreaInput
                  name="body"
                  type="text"
                  rows={2}
                  className={`inline-css scrollbar-styling`}
                  label={localization.note}
                  value={note}
                  inputValue={note}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => {
                    setNote(e.target.value);
                  }}
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <ConstantInput
                  label={localization.complaintIn90Days}
                  type="number"
                  value={complaintRaised}
                  required={true}
                  isStarRequired={true}
                  //errorMsg={localization.isRequired}
                  //disabled={disabled}
                  handleChange={(val) => {
                    setComplaintRaised(val);
                  }}
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <ConstantInput
                  label={localization.complaintResolved}
                  type="number"
                  value={complaintResolved}
                  required={true}
                  isStarRequired={true}
                  //errorMsg={localization.isRequired}
                  //disabled={disabled}
                  handleChange={(val) => {
                    setComplaintResolved(val);
                  }}
                />
              </div>
              <div className="col-md-6 col-sm-12">
                <ConstantInput
                  label={localization.monthlyAverage}
                  type="number"
                  value={monthlyAverage}
                  required={true}
                  isStarRequired={true}
                  //errorMsg={localization.isRequired}
                  //disabled={disabled}
                  handleChange={(val) => {
                    setMonthlyAverage(val);
                  }}
                />
              </div>
              <div className="col-md-12 col-sm-12">
                <FileUpload
                  id={"addAttachment"}
                  accept=".pdf,.png,.jpg,.jpeg,.doc,.mp4,.webm,.mkv"
                  documentUploadUrl={documentUploadUrlPublic}
                  documentUrlData={documentUrlDataPublic}
                  onChange={(val) => saveMomDoc(val)}
                  //multiple={true}
                >
                  <span className="btn btn-transparent">
                    {localization.media}
                  </span>
                </FileUpload>
              </div>
            </div>
            <div
              style={{ "margin-top": "20px" }}
              className="col-md-12 col-sm-5"
            >
              <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default CreateMom;
